"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.list = list;
exports.create = create;
exports.update = update;
exports.remove = remove;
exports.unread = unread;
exports.statistic = statistic;
exports.endpoints = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _requests = require("@edison/requests");

var _functools = require("@edison/functools");

var _utils = require("./utils");

var _constants = require("../utils/constants");

var endpoints = {
  list: {
    method: 'GET',
    url: function url() {
      return "/".concat(_constants.API_V1, "/label_list");
    }
  },
  create: {
    method: 'POST',
    url: function url() {
      return "/".concat(_constants.API_V1, "/create_label");
    }
  },
  update: {
    method: 'PUT',
    url: function url(labelId) {
      return "/".concat(_constants.API_V1, "/update_label/").concat(labelId);
    }
  },
  remove: {
    method: 'DELETE',
    url: function url(labelId) {
      return "/".concat(_constants.API_V1, "/delete_label/").concat(labelId);
    }
  },
  unread: {
    method: 'GET',
    url: function url() {
      return "/".concat(_constants.API_V1, "/thread/label_list_with_unread");
    }
  },
  statistic: {
    method: 'GET',
    url: function url() {
      return "/".concat(_constants.API_V1, "/label_statistic");
    }
  }
};
exports.endpoints = endpoints;

/**
 * Return a list of folders
 *
 * @public
 * @param {Auth} auth - User validated authentication
 * @returns {Promise<LabelListResponse>}
 * @throws {RequestError}
 */
function list(_x) {
  return _list.apply(this, arguments);
}

function _list() {
  _list = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(_ref) {
    var auth, optionals, _endpoints$list, method, url;

    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            auth = _ref.auth;
            optionals = (0, _utils.withAuth)(auth)(_utils.defaultOptionals);
            _endpoints$list = endpoints.list, method = _endpoints$list.method, url = _endpoints$list.url;
            _context.next = 5;
            return (0, _requests.request)(url(), method, optionals);

          case 5:
            return _context.abrupt("return", _context.sent);

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _list.apply(this, arguments);
}

/**
 * Create a new label
 *
 * @public
 * @param {Auth} auth - User validated authentication
 * @param {string} name - Name for the new label
 * @returns {Promise<LabelCreateResponse>}
 */
function create(_x2, _x3) {
  return _create.apply(this, arguments);
}

function _create() {
  _create = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(_ref2, _ref3) {
    var name, color, auth, optionals, _endpoints$create, method, url, res;

    return _regenerator["default"].wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            name = _ref2.name, color = _ref2.color;
            auth = _ref3.auth;
            optionals = (0, _functools.compose)((0, _utils.withAuth)(auth), (0, _requests.withBody)({
              name: name,
              color: color
            }))(_utils.defaultOptionals);
            _endpoints$create = endpoints.create, method = _endpoints$create.method, url = _endpoints$create.url;
            _context2.next = 6;
            return (0, _requests.request)(url(), method, optionals);

          case 6:
            res = _context2.sent;
            return _context2.abrupt("return", res);

          case 8:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _create.apply(this, arguments);
}

/**
 * Update an existed label
 *
 * @public
 * @param {string} labelId - Uniq ID for label
 * @param {string} name - Name for label
 * @param {string} color - Color for label
 * @param {Auth} auth - User validated authentication
 * @returns {Promise<LabelUpdateReponse>}
 */
function update(_x4, _x5, _x6) {
  return _update.apply(this, arguments);
}

function _update() {
  _update = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(labelId, _ref4, _ref5) {
    var name, color, auth, optionals, _endpoints$update, method, url, res;

    return _regenerator["default"].wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            name = _ref4.name, color = _ref4.color;
            auth = _ref5.auth;
            optionals = (0, _functools.compose)((0, _utils.withAuth)(auth), (0, _requests.withBody)({
              name: name,
              color: color
            }))(_utils.defaultOptionals);
            _endpoints$update = endpoints.update, method = _endpoints$update.method, url = _endpoints$update.url;
            _context3.next = 6;
            return (0, _requests.request)(url(labelId), method, optionals);

          case 6:
            res = _context3.sent;
            return _context3.abrupt("return", res);

          case 8:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _update.apply(this, arguments);
}

/**
 * Remove an existed label
 *
 * @public
 * @param {string} labelId - Uniq ID for label
 * @param {Auth} auth - User validated authentication
 * @returns {Promise<LabelRemoveResponse>}
 */
function remove(_x7, _x8) {
  return _remove.apply(this, arguments);
}

function _remove() {
  _remove = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4(labelId, _ref6) {
    var auth, optionals, _endpoints$remove, method, url, res;

    return _regenerator["default"].wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            auth = _ref6.auth;
            optionals = (0, _utils.withAuth)(auth)(_utils.defaultOptionals);
            _endpoints$remove = endpoints.remove, method = _endpoints$remove.method, url = _endpoints$remove.url;
            _context4.next = 5;
            return (0, _requests.request)(url(labelId), method, optionals);

          case 5:
            res = _context4.sent;
            return _context4.abrupt("return", res);

          case 7:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _remove.apply(this, arguments);
}

/**
 * Returns the labels with unread number
 *
 * @public
 * @param {Auth} auth - User valid authentication
 * @returns {Promise<LabelUnreadResponse>}
 */
function unread(_x9) {
  return _unread.apply(this, arguments);
}

function _unread() {
  _unread = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5(_ref7) {
    var auth, accountLabel, optionals, _endpoints$unread, method, url, res;

    return _regenerator["default"].wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            auth = _ref7.auth, accountLabel = _ref7.accountLabel;
            optionals = (0, _functools.compose)((0, _utils.withAuth)(auth), (0, _requests.withParams)({
              account_label: accountLabel
            }))(_utils.defaultOptionals);
            _endpoints$unread = endpoints.unread, method = _endpoints$unread.method, url = _endpoints$unread.url;
            _context5.next = 5;
            return (0, _requests.request)(url(), method, optionals);

          case 5:
            res = _context5.sent;
            return _context5.abrupt("return", res);

          case 7:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return _unread.apply(this, arguments);
}

function statistic(_x10) {
  return _statistic.apply(this, arguments);
}

function _statistic() {
  _statistic = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee6(_ref8) {
    var auth, accountLabel, optionals, _endpoints$statistic, method, url, res;

    return _regenerator["default"].wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            auth = _ref8.auth, accountLabel = _ref8.accountLabel;
            optionals = (0, _functools.compose)((0, _utils.withAuth)(auth), (0, _requests.withParams)({
              account_label: accountLabel
            }))(_utils.defaultOptionals);
            _endpoints$statistic = endpoints.statistic, method = _endpoints$statistic.method, url = _endpoints$statistic.url;
            _context6.next = 5;
            return (0, _requests.request)(url(), method, optionals);

          case 5:
            res = _context6.sent;
            return _context6.abrupt("return", res);

          case 7:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));
  return _statistic.apply(this, arguments);
}
//# sourceMappingURL=labels.js.map